import React from 'react';

import { IconInfoCircle } from '@trqk/components';

import { locale } from '@trqk/utils';

/**
 * An empty state that is shown when there are no active audio uploads.
 */
export const AudioUploadsEmptyState = (): JSX.Element => (
        <div className="w-full h-full flex items-center justify-center">
            <div className="flex flex-col items-center text-tertiary-400 italic space-y-4">
                <div className="flex items-center">
                    <IconInfoCircle addClasses="mr-2" />
                    {
                        locale.enUS.MANAGE_DETECTIONS.UPLOADS.EMPTY_STATE
                            .NO_ACTIVE_UPLOADS
                    }
                </div>
                <div className="text-center w-2/3">
                    {
                        locale.enUS.MANAGE_DETECTIONS.UPLOADS.EMPTY_STATE
                            .DETAILS_SHOWN_HERE
                    }
                </div>
            </div>
        </div>
    );
